import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FinalClientService } from "../services/final-client.service";
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { WizardService } from '../../../shared/service/wizard.service';
import { PlaceFilterForm } from '../../operator/models/PlaceFilterForm';
import { Page } from 'src/app/shared/model/page';
import { Place } from '../models/Place';
import { NetworkContractFilterForm } from '../../operator/models/NetworkContractFilterForm';
import { RequestFilterForm } from '../../operator/models/RequestFilterForm';
import * as moment from 'moment/moment';
import {
  ModalContractCancelComponent
} from "../../../shared/components/modal-contract-cancel/modal-contract-cancel.component";
import {Observable, throwError} from "rxjs";
import {catchError, tap} from "rxjs/operators";

@Component({
  selector: 'app-personal-gas-consumption-place',
  templateUrl: './final-client-gas.component.html',
  styleUrls: ['./final-client-gas.component.scss']
})
export class FinalClientGasComponent implements OnInit {

  public clcValue: string = '';
  public gasConsumptionPlaces: Page<Place>;
  public gasContracts: Page<any>;
  public gasRequests: Page<any>;
  public placeFilterForm: PlaceFilterForm = new PlaceFilterForm();
  public gasContractFilterForm: NetworkContractFilterForm = new NetworkContractFilterForm();
  public gasRequestFilterForm: RequestFilterForm = new RequestFilterForm();
  public paginationGasConsumptionPlaces = [];
  public paginationGasContracts = [];
  public paginationGasRequests = [];
  private consumptionPlaceError = 'Va rugam sa va asigurati ca ati introdus POD/CLC corect. Daca este corect introdus, este posibil ca locul de consum pe care incercati sa il asociati sa nu fie inca introdus in platforma de catre Operatorul de retea. Va rugam sa sesizati aceasta situatie catre Furnizorul cu care aveti contract de furnizare.';

  @ViewChild(NgbTabset, { static: false }) tabset: NgbTabset;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

  constructor(
    private finalClientService: FinalClientService,
    private wizardService: WizardService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.searchPlaces();
    this.searchContracts();
    this.searchRequests();
  }

  searchRequests(): void {
    this.finalClientService.getFCGasRequests(this.gasRequestFilterForm).subscribe((val) => {
      this.gasRequests = val;
      this.gasRequestFilterForm.pageOffset = val.number;
      this.paginationGasRequests = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasRequests.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasRequests[this.gasRequestFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changeRequestPage(page: any): void {
    this.gasRequestFilterForm.pageOffset = page.pageNumber;
    this.searchRequests();
  }

  previousRequestPage(): void {
    this.gasRequestFilterForm.pageOffset = this.gasRequestFilterForm.pageOffset === 0 ? 0 : this.gasRequestFilterForm.pageOffset - 1;
    this.searchRequests();
  }

  nextRequestPage(): void {
    this.gasRequestFilterForm.pageOffset = this.gasRequestFilterForm.pageOffset === this.gasRequests.totalPages - 1
      ? this.gasRequestFilterForm.pageOffset : this.gasRequestFilterForm.pageOffset + 1;
    this.searchRequests();
  }

  searchContracts(): void {
    this.finalClientService.getFCGasContracts(this.gasContractFilterForm).subscribe((val) => {
      this.gasContracts = val;
      this.gasContractFilterForm.pageOffset = val.number;
      this.paginationGasContracts = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasContracts.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasContracts[this.gasContractFilterForm.pageOffset].className = 'page-item active';
    });
  }

  searchActiveContractsByPlaceId(placeId): Observable<Page<any>> {
    const filterForm = new NetworkContractFilterForm();
    filterForm.placeId = placeId;
    filterForm.active = true;
    return this.finalClientService.getFCGasContracts(filterForm);
  }

  searchActiveRequestsByPlaceId(placeId): Observable<Page<any>> {
    const filterForm = new RequestFilterForm();
    filterForm.placeId = placeId;
    filterForm.active = true;
    return this.finalClientService.getFCGasRequests(filterForm);
  }

  changeContractPage(page: any): void {
    this.gasContractFilterForm.pageOffset = page.pageNumber;
    this.searchContracts();
  }

  previousContractPage(): void {
    this.gasContractFilterForm.pageOffset = this.gasContractFilterForm.pageOffset === 0 ? 0 : this.gasContractFilterForm.pageOffset - 1;
    this.searchContracts();
  }

  nextContractPage(): void {
    this.gasContractFilterForm.pageOffset = this.gasContractFilterForm.pageOffset === this.gasContracts.totalPages - 1
      ? this.gasContractFilterForm.pageOffset : this.gasContractFilterForm.pageOffset + 1;
    this.searchContracts();
  }

  searchPlaces(): void {
    this.finalClientService.getFCGasConsumptionPlaces(this.placeFilterForm).subscribe((val) => {
      this.gasConsumptionPlaces = val;
      this.placeFilterForm.pageOffset = val.number;
      this.paginationGasConsumptionPlaces = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationGasConsumptionPlaces.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationGasConsumptionPlaces[this.placeFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changePage(page: any): void {
    this.placeFilterForm.pageOffset = page.pageNumber;
    this.searchPlaces();
  }

  previousPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === 0 ? 0 : this.placeFilterForm.pageOffset - 1;
    this.searchPlaces();
  }

  nextPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === this.gasConsumptionPlaces.totalPages - 1
      ? this.placeFilterForm.pageOffset : this.placeFilterForm.pageOffset + 1;
    this.searchPlaces();
  }

  associateConsumptionPlace(): void {
    if (this.clcValue !== "" && this.clcValue !== null) {
      this.finalClientService.associateFCGasConsumptionPlace(this.clcValue).subscribe((val) => {
        this.searchPlaces();
        this.searchContracts();
        this.searchRequests();
        this.successAssociationNotification();
      }, error => {
        if (error) {
          this.errorNotification(error.error.message);
        }
      });
    } else {
      this.errorNotification(this.consumptionPlaceError);
    }
  }

  onCustomActionContracts(event: any): void {
    switch (event.action) {
      case 'supplierChange':
        // this.errorNotification('Momentan indisponibil.');
        this.searchActiveRequestsByPlaceId(event.data.placeId).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements > 0) {
              this.errorNotification('Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.');
            } else {
              this.wizardService.setWizardInformation({
                comparatorType: 'gas',
                editable: 'true',
                previousContractId: String(event.data.id),
                previousContractNumber: String(event.data.number),
                supplierId: String(event.data.supplierId),
                placeId: String(event.data.placeId),
                clientTypePF: 'true',
                supplierLicence: String(event.data.supplierLicence)
              });
              this.router.navigate(
                ['/utilizator/comparator'],
                {
                  queryParams: {
                    comparatorType: 'gas',
                    editable: 'true',
                    contractNumber: String(event.data.number),
                    supplierId: String(event.data.supplierId),
                    placeId: String(event.data.placeId),
                    clientTypePF: 'true'
                  }
                }
              );
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();
        break;
      case 'additionalAct':
        break;
      case 'recall':
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: '<span>Încetarea contractului de furnizare pentru alte motive decât schimbarea furnizorului se realizează prin intermediul furnizorului dumneavoastră. Contactați furnizorul în afara POSF pentru asistență în privința încetării contractului de furnizare.</span><br><span>*În situația în care aveți încheiat un contract de distribuție direct cu operatorul de distribuție este necesar să contactați direct operatorul de distribuție pentru încetarea lui.</span>',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
          customClass: {
            popup: 'popup-z-elevate-24-blue'
          }
        });

        /*
        this.searchActiveContractsByPlaceId(event.data.placeId).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements < 2) {
              Swal.fire({
                html: 'Atenție! Această operațiune va trece locul dumneavoastră de consum la furnizorul de ultimă instanță. Doriți să continuați?\n' +
                  '*Dacă nu mai doriți alimentarea locului de consum luați legătura cu furnizorul dumneavoastră pentru a vă înregistra această opțiune.',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Anuleaza',
                customClass: {
                  popup: 'popup-z-elevate-24-blue'
                }
              }).then(result => {
                if (result.value) {
                  this.openCancelModal();
                  this.finalClientService.cancelContract(event.data.id).subscribe().add(async () => {
                    this.searchContracts();
                    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
                    await sleep(5000);
                    Swal.close();
                  });
                }
              });
            } else {
              Swal.fire({
                html: 'Esti sigur ca vrei sa renunti la acest contract?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Anuleaza',
                customClass: {
                  popup: 'popup-z-elevate-24-blue'
                }
              }).then(result => {
                if (result.value) {
                  this.openCancelModal();
                  this.finalClientService.cancelContract(event.data.id).subscribe().add(async () => {
                    this.searchContracts();
                    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
                    await sleep(5000);
                    Swal.close();
                  });
                }
              });
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta contractelor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();
        */
        break;
      case 'sendIndex':
        this.router.navigate(['index'], {
          relativeTo: this.route, queryParams: {
            contractId: String(event.data.id),
            contractNumber: String(event.data.number),
            placeCode: String(event.data.placeCode),
          }
        });
        break;
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          editable: 'false',
          contractNumber: String(event.data.number),
          supplierId: String(event.data.supplierId),
          placeId: String(event.data.placeId),
          clientTypePF: 'true',
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments),
          wizard: JSON.stringify(event.data.wizard)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  onCustomActionConsumptionPlace(event: any): void {
    switch (event.action) {
      case 'newContract':
        //this.errorNotification('Momentan indisponibil.');

        this.searchActiveRequestsByPlaceId(event.data.id).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements > 0) {
              this.errorNotificationHtml('Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.');
            } else {

              this.searchActiveContractsByPlaceId(event.data.id).pipe(
                tap((val: Page<any>) => {
                  if (val.totalElements > 0) {
                    this.errorNotificationHtml('Atenție! Pe acest loc de consum există contract de furnizare activ.\n' +
                      'Dacă doriți să realizați schimbarea furnizorului, accesați tab-ul Contracte, identificați contractul pe care doriți să-l schimbați și selectați din dreptul acestuia opțiunea “Schimbă furnizor”.');
                  } else {
                    this.wizardService.setWizardInformation({
                      comparatorType: 'gas',
                      clientTypePF: 'true',
                      editable: 'true',
                      placeId: String(event.data.id)
                    });
                    this.router.navigate(
                      ['/utilizator/comparator'],
                      {
                        queryParams: {
                          comparatorType: 'gas',
                          clientTypePF: 'true',
                          editable: 'true',
                          placeId: String(event.data.id)
                        }
                      }
                    );
                  }
                }),
                catchError((error) => {
                  this.errorNotification('Nu s-a putut verifica existenta contractelor active pe locul de consum selectat.');
                  return throwError(error);
                })
              ).subscribe();
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();

        break;
      case 'consumptionPlaceDetails':
        this.router.navigate(['loc-consum'], { relativeTo: this.route, state: { placeId: event.data.id, editable: false } });
        break;
      case 'viewExistingContracts':
        this.gasContractFilterForm.placeId = event.data.id;
        this.searchContracts();
        this.tabset.select('contracts');
        break;
      case 'disassociateConsumptionPlace':
        this.finalClientService.disassociateFCConsumptionPlace(event.data.code).subscribe((val) => {
          this.searchPlaces();
          this.searchContracts();
          this.searchRequests();
          this.successDisassociationNotification();
        }, error => {
          if (error) {
            this.errorNotification(error.error.message);
          }
        });
        break;
    }
  }

  onCustomActionRequests(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          clientTypePF: 'true',
          editable: 'false',
          requestObservations: String(event.data.requestReason),
          wizard: JSON.stringify(event.data.wizard),
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments),
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: 'Esti sigur ca vrei sa renunti la aceasta cerere?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
           customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
        }).then(result => {
          if (result.value) {
            this.openCancelModal();
            this.finalClientService.cancelRequest(event.data.id).subscribe().add(async () => {
              this.searchRequests();
              const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
              await sleep(5000);
              Swal.close();
            });
          }
        });
        break;
      case 'complete':
        this.wizardService.setWizardInformation({
          comparatorType: 'gas',
          clientTypePF: 'true',
          editable: 'true',
          requestId: String(event.data.id),
          requestObservations: String(event.data.requestReason),
          wizard: JSON.stringify(event.data.wizard)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  public contractSettings = {
    actions: {
      custom: [
        {
          name: 'supplierChange',
          title: '<p class="actionSF" >Schimba furnizor</p>'
        },
        {
          name: 'sendIndex',
          title: '<p class="actionTI">Trimitere index</p>'
        },
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'recall',
          title: '<p class="actionR">Renunta</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionS">Anuleaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status == 'ACTIV') {
        const today = moment().startOf('day');
        const startingDate = row.data.startingDate && moment(row.data.startingDate);
        const indexDate = row.data.indexDate ? moment(row.data.indexDate) : moment.unix(0);
        if (
          startingDate && today.diff(startingDate, 'days') === 0 &&
          indexDate && indexDate.diff(startingDate, 'days') < 0
        ) {
          _class += 'row_c_activTI ';
        } else {
          _class += 'row_c_activ ';
        }
        if (row.data.placeStatus === 'DEZAFECTAT') {
          _class += 'row_dezafectat ';
        }
      } else if (row.data.status == 'INCETAT') {
        _class += 'row_c_incetat';
      } else if (row.data.status == 'SUSPENDAT') {
        _class += 'row_c_suspendat';
      } else if (row.data.status == 'ACTIV (in curs de schimbare)') {
        _class += 'row_c_activS';
      } else if (row.data.status == 'ACTIV (neintrat in vigoare)') {
        _class += 'row_c_activNV';
      } else {
        _class += 'xxxxx';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      placeCode: {
        title: 'CLC'
      },
      address: {
        title: 'Adresa'
      },
      number: {
        title: 'Numar'
      },
      startingDate: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      operator: {
        title: 'Operator loc consum'
      }
      ,
      supplierName: {
        title: 'Furnizor'
      }
      ,
      contractType: {
        title: 'Tip contract'
      }
      ,
      expirationDate: {
        title: 'Valabil pana la',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      }
      ,
      status: {
        title: 'Status'
      }
    },
  };

  public consumptionPlaceSettings = {
    actions: {
      custom: [
        {
          name: 'consumptionPlaceDetails',
          title: '<p>Detalii</p>'
        },
        {
          name: 'newContract',
          title: '<p class="actionCN">Adauga contract nou</p>'
        },
        {
          name: 'viewExistingContracts',
          title: '<p>Vizualizeaza contracte existente</p>'
        },
        {
          name: 'disassociateConsumptionPlace',
          title: '<p>Dezasociaza loc de consum</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (row.data.status === 'DEZAFECTAT') {
        _class += 'row_dezafectat ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      code: {
        title: 'CLC'
      },
      address: {
        title: 'Adresa'
      },
      status: {
        title: 'Status'
      }
    },
  };

  public requestSettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionA">Anuleaza</p>'
        },
        {
          name: 'complete',
          title: '<p class="actionR">Recompleteaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status === 'Informatii suplimentare') {
        _class += 'row_more_info ';
      } else if (row.data.status === 'Anulata' || row.data.status === 'Finalizata') {
        _class += 'row_finished ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      id: {
        title: 'Numar cerere'
      },
      placeCode: {
        title: 'CLC'
      },
      address: {
        title: 'Adresa'
      },
      contractNumber: {
        title: 'Numar contract'
      },
      startingDate: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      operator: {
        title: 'Operator loc consum'
      },
      supplier: {
        title: 'Furnizor'
      },
      date: {
        title: 'Data transmitere',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      }
    },
  };

  successAssociationNotification(): void {
    Swal.fire({
      title: ' ',
      text: 'Locul de consum ' + this.clcValue + ' a fost asociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  successDisassociationNotification(): void {
    Swal.fire({
      title: '',
      text: 'Locul de consum ' + this.clcValue + ' a fost dezasociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  errorNotificationHtml(message: string): void {
    Swal.fire({
      title: ' ',
      html: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  openCancelModal(): void {
    const modalHtml = this.getTemplateAsString();
    const swalInstance = Swal.fire({
      html: modalHtml,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  getTemplateAsString(): string {
    const componentRef = this.container.createComponent(ModalContractCancelComponent);
    const template = componentRef.location.nativeElement.innerHTML;
    // console.log(template); // Output the template as a string
    componentRef.destroy(); // Destroy the dynamically created component
    return template;
  }


}
